import script from "./TemaElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemaElement.vue?vue&type=script&setup=true&lang=ts"

export default script